// ATC -> add via AJAX -> ENSURE drawer is mounted -> fetch fresh HTML -> swap drawer inner -> keep open
// v2.3 US+AU hardening
// - NEW: Prefer reading the live drawer's section id from DOM ([data-section-id]/[data-section]) once mounted
// - Fallbacks: broadened section keys + /cart?view=drawer | /cart?view=mini
// - More resilient "open" logic + small waits so the drawer mounts before sniffing ids

console.log('[ATC] us-master mounted flow v2.3');

(function () {
  if (window.__ATC_PATCHED__) return;
  window.__ATC_PATCHED__ = true;

  // ---- AUTO-HOOK: tag any /cart/add buttons so clicks are intercepted ----
  (function autoHookATC() {
    const FORM_SEL = 'form[action*="/cart/add"]';
    const hook = () => {
      document.querySelectorAll(
        `${FORM_SEL} button, ${FORM_SEL} [type="submit"], ${FORM_SEL} a[role="button"], ${FORM_SEL} [role="button"]`
      ).forEach((el) => {
        if (!el.hasAttribute('data-atc')) el.setAttribute('data-atc', '');
        if (el.tagName === 'BUTTON' && el.type.toLowerCase() === 'submit') el.type = 'button';
      });
    };
    hook();
    new MutationObserver(hook).observe(document.documentElement, { childList: true, subtree: true });
  })();

  // ---- Config / selectors ----
  const SECTION_KEYS = [
    // common header wrappers that often contain drawer
    'header-group', 'header', 'group-header', 'site-header', 'layout-header', 'header-section',
    // common drawer ids across themes
    'cart-drawer', 'main-cart-drawer', 'ajax-cart-drawer', 'cart-side-drawer',
    'cart-notification', 'cart-items', 'cart-drawer-items'
  ];

  const DRAWER_INNER_SELECTORS = [
    'dialog.cart-drawer__dialog .cart-drawer__content',
    'cart-drawer-component .cart-drawer__content',
    '#CartDrawer .cart-drawer__content',
    '#CartDrawer .drawer__inner',
    '.mini-cart__content',
    '[data-cart-drawer-content]'
  ];

  const CURRENT_ROOT_SELECTORS = [
    'dialog.cart-drawer__dialog .cart-drawer__content',
    'cart-drawer-component .cart-drawer__content',
    '#CartDrawer .cart-drawer__content',
    '#CartDrawer .drawer__inner',
    '.mini-cart__content',
    '[data-cart-drawer-content]'
  ];

  // ---- tiny helpers ----
  const $ = (s, r = document) => r.querySelector(s);
  const $all = (s, r = document) => Array.from(r.querySelectorAll(s));
  const sleep = (ms) => new Promise(r => setTimeout(r, ms));

  function findForm(el) {
    return el?.closest?.('form[action*="/cart/add"]') || el?.closest?.('form') || null;
  }

  async function addToCart(form) {
    const fd = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.description || 'Add to cart failed');
    return data;
  }

  async function fetchSections(keys) {
    const res = await fetch('/?sections=' + encodeURIComponent(keys.join(',')), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store',
    });
    if (!res.ok) return null;
    try { return await res.json(); } catch { return null; }
  }

  function currentDrawerInner() {
    return CURRENT_ROOT_SELECTORS.map(sel => $(sel)).find(Boolean) || null;
  }

  function getLiveSectionId() {
    // Prefer reading the outer drawer section id from the mounted DOM
    const inner = currentDrawerInner();
    if (!inner) return null;
    const host =
      inner.closest('[data-section-id]') ||
      inner.closest('[data-section]') ||
      inner.closest('[section-id]');
    if (!host) return null;
    return host.dataset.sectionId || host.dataset.section || host.getAttribute('section-id') || null;
  }

  function openViaDialog() {
    const dlg = $('dialog.cart-drawer__dialog');
    if (dlg && !dlg.open && typeof dlg.showModal === 'function') dlg.showModal();
    return !!(dlg && dlg.open);
  }

  function clickHeaderToggle() {
    const btn =
      $('button[aria-label^="Open cart"]') ||
      $('[data-open-cart]') ||
      $('[data-action="open-cart"]') ||
      $('[data-cart-toggle]') ||
      $('button[aria-controls*="Cart"], button[aria-controls*="cart"]');
    if (btn) {
      btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      return true;
    }
    return false;
  }

  function openDrawerIfNeeded() {
    if (openViaDialog()) return true;
    return clickHeaderToggle();
  }

  async function ensureDrawerMounted() {
    if (currentDrawerInner()) return true;
    openDrawerIfNeeded();
    // Give the theme a moment to mount the drawer DOM
    await sleep(90);
    if (currentDrawerInner()) return true;
    // Try once more (some themes lazy-mount after a frame)
    await sleep(90);
    return !!currentDrawerInner();
  }

  function extractFreshInner(html) {
    const tmp = document.createElement('div'); tmp.innerHTML = html;
    return DRAWER_INNER_SELECTORS.map(sel => tmp.querySelector(sel)).find(Boolean) || null;
  }

function swapDrawerInnerFromHTML(html) {
  const fresh = extractFreshInner(html);
  const live = currentDrawerInner();
  if (fresh && live) {
    // Replace node (safer for event listeners than innerHTML in some themes)
    const newNode = live.cloneNode(false);
    newNode.innerHTML = fresh.innerHTML;
    live.replaceWith(newNode);
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:change'));
    document.dispatchEvent(new CustomEvent('cart:updated')); // Trigger milestones
    return true;
  }
  return false;
}

  async function refreshBubble() {
    try {
      const r = await fetch('/?sections=cart-icon-bubble', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' });
      if (!r.ok) return;
      const j = await r.json().catch(() => null);
      const tmp = document.createElement('div'); tmp.innerHTML = j?.['cart-icon-bubble'] || '';
      const fresh = tmp.querySelector('#cart-icon-bubble'); const curr = $('#cart-icon-bubble');
      if (fresh && curr) curr.replaceWith(fresh);
    } catch {}
  }

  async function fetchFreshDrawerHTML() {
    // 1) If we can read the live section id from DOM, use that first (most reliable)
    const liveId = getLiveSectionId();
    if (liveId) {
      const j = await fetchSections([liveId]);
      const html = j && j[liveId];
      if (html) return html;
    }

    // 2) Try our broadened key list
    const j2 = await fetchSections(SECTION_KEYS);
    if (j2) {
      for (const k of SECTION_KEYS) {
        if (j2[k] && extractFreshInner(j2[k])) return j2[k];
      }
    }

    // 3) Fallback to views that many themes expose
    //    Note: harmless fetch if not present; we only use it if it contains a drawer content root
    const views = ['/cart?view=drawer', '/cart?view=mini'];
    for (const url of views) {
      try {
        const r = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' });
        if (!r.ok) continue;
        const html = await r.text();
        if (extractFreshInner(html)) return html;
      } catch {}
    }

    return null;
  }

  // ---- handlers ----
  function resolveATC(t) { return t?.closest?.('[data-atc]') || null; }

  async function handleClick(e) {
    const btn = resolveATC(e.target);
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    const form = findForm(btn);
    if (!form) return;

    btn.setAttribute('aria-busy', 'true');

    try {
      // 1) Add item
      await addToCart(form);

      // 2) Ensure drawer DOM is mounted so we can sniff its section id
      await ensureDrawerMounted();

      // 3) Fetch fresh drawer HTML using robust detection/fallbacks
      const html = await fetchFreshDrawerHTML();

// 4) Swap
const swapped = html ? swapDrawerInnerFromHTML(html) : false;

// 5) Ensure it's visible (now populated)
setTimeout(openDrawerIfNeeded, 10);

// 6) Update bubble
refreshBubble();

if (swapped) {
  btn.classList.add('is-added');
  setTimeout(() => btn.classList.remove('is-added'), 900);
  
  // 7) Trigger milestone system update
  document.dispatchEvent(new CustomEvent('cart:updated'));
} else {
  console.warn('[ATC] Drawer refresh fallback did not swap; check section id/templates.');
}
    } catch (err) {
      console.error('[ATC] error', err);
    } finally {
      btn.removeAttribute('aria-busy');
    }
  }

  function handleSubmit(e) {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (!form.querySelector('[data-atc]')) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    const btn = form.querySelector('[data-atc]') || form.querySelector('[type="submit"]');
    if (btn) btn.click();
  }

  document.addEventListener('click', handleClick, { capture: true });
  document.addEventListener('submit', handleSubmit, { capture: true });
})();
